import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var YearlyDistributionsAccrued =
/*#__PURE__*/
function (_BaseData) {
  _inherits(YearlyDistributionsAccrued, _BaseData);

  function YearlyDistributionsAccrued() {
    _classCallCheck(this, YearlyDistributionsAccrued);

    return _possibleConstructorReturn(this, _getPrototypeOf(YearlyDistributionsAccrued).call(this, "YearlyDistributionsAccrued"));
  }

  _createClass(YearlyDistributionsAccrued, [{
    key: "GetByComputationOfDistributionId",
    value: function () {
      var _GetByComputationOfDistributionId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(computationOfDistributionId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByComputationOfDistributionId/").concat(computationOfDistributionId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByComputationOfDistributionId(_x) {
        return _GetByComputationOfDistributionId.apply(this, arguments);
      }

      return GetByComputationOfDistributionId;
    }()
  }, {
    key: "GetByComputationOfDistributionIdAllowCreate",
    value: function () {
      var _GetByComputationOfDistributionIdAllowCreate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(computationOfDistributionId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByComputationOfDistributionIdAllowCreate/").concat(computationOfDistributionId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetByComputationOfDistributionIdAllowCreate(_x2) {
        return _GetByComputationOfDistributionIdAllowCreate.apply(this, arguments);
      }

      return GetByComputationOfDistributionIdAllowCreate;
    }()
  }]);

  return YearlyDistributionsAccrued;
}(BaseData);

export default new YearlyDistributionsAccrued();